export const DATA = [
    {
      title: 'ANASAYFA',
      link: '/'
    },
    {
      title: 'KURUMSAL',
      link: '/hakkimizda',
      
  
    },
    {
      title: 'HİZMETLERİMİZ',
      link: '/hizmetlerimiz',
  
    },
    {
      title: 'PROJELER',
      link: '/biten-projeler',
      dropDown: [
        {
          title: 'House',
          link: '/house',
        },
        {
          title: 'U-Mega',
          link: '/u-mega',
        },
        {
          title: 'U-Stock',
          link: '/u-stock',
        },
        {
          title: 'U-Port',
          link: '/u-port',
        },
        {
          title: 'Biten Projeler',
          link: '/biten-projeler',
        },
        // {
        //   title: 'Devam Eden Projeler',
        //   link: '/devam-eden-projeler',
        // },
  
      ]
    },
    {
      title: 'İLETİŞİM',
      link: '/iletisim',
  
    },
  
  
  ]